import React from 'react';
import { C, nx, ny, halfW, halfH } from '../flowCanvas.constants';

// Orthogonal connector — all segments are strictly horizontal or vertical.
export default function Connector({ from, to, centreY, yOverrides, xOverrides, fromYOverride, toYOverride, fromXAnchorOverride, toXAnchorOverride, branchXOverride }) {
  const xOf = (step) => xOverrides?.[step.stepId] ?? nx(step);
  const yOf = (step) => yOverrides?.[step.stepId] ?? ny(step, centreY);

  const fx = xOf(from), fy = fromYOverride ?? yOf(from);
  const tx = xOf(to),   ty = toYOverride   ?? yOf(to);

  const sameY = Math.abs(fy - ty) < 2;
  const sameX = Math.abs(fx - tx) < 2;

  // Source exits from its right edge; target enters from its left edge
  const x1 = fromXAnchorOverride ?? (fx + halfW(from));
  const x2 = toXAnchorOverride ?? (tx - halfW(to));

  let d;
  if (sameY) {
    d = `M ${x1} ${fy} H ${x2}`;
  } else if (sameX) {
    const y1 = fy + (ty > fy ?  halfH(from) : -halfH(from));
    const y2 = ty + (ty > fy ? -halfH(to)   :  halfH(to));
    d = `M ${fx} ${y1} V ${y2}`;
  } else {
    const minX = Math.min(x1, x2);
    const maxX = Math.max(x1, x2);
    const unclampedMidX = branchXOverride ?? ((x1 + x2) / 2);
    const midX = Math.max(minX + 8, Math.min(maxX - 8, unclampedMidX));
    d = `M ${x1} ${fy} H ${midX} V ${ty} H ${x2}`;
  }

  const complete   = from.populatedData?.isComplete && to.populatedData?.isComplete;
  const incomplete = from.populatedData?.isComplete === false || to.populatedData?.isComplete === false;
  const color      = complete ? C.purple : incomplete ? C.orange : C.purple;
  const strokeOpacity = color === C.purple ? 0.82 : 0.85;
  const dotOpacity = color === C.purple ? 0.9 : 0.95;

  return (
    <g>
      <path d={d} stroke={color} strokeWidth="1.5" fill="none" strokeOpacity={strokeOpacity} strokeLinecap="square" />
      <circle cx={x2} cy={ty} r="3" fill={color} fillOpacity={dotOpacity} />
    </g>
  );
}
